import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const StyledDetails = styled.div`
    display: grid;
`;

const StyledSubTitle = styled.h4`
    border-bottom: 1px solid ${({ theme }) => theme.gray7};
    margin-bottom: 1rem;
    padding-bottom: 0.2em;
    font-weight: 300;
    text-transform: uppercase;
`;

const InfoSection: React.FC<{ title?: string; children: React.ReactNode }> = ({ title, children }) => {
    const intl = useIntl();

    return (
        <div>
            {title && <StyledSubTitle>{intl.formatMessage({ id: title })}</StyledSubTitle>}
            <StyledDetails>{children}</StyledDetails>
        </div>
    );
};

export default InfoSection;
